export class SummaryItem {
  constructor() {
    this.Header = "";
    this.Description = "";
  }

  public Header: string;
  public Description: string;
}
